import heroPerson from "../../assets/home-page/hero-banner-visual/hero-person-with-phone.png";
import avatar1 from "../../assets/home-page/hero-banner-visual/avatar-user-1.jpg";
import avatar2 from "../../assets/home-page/hero-banner-visual/avatar-user-2.jpg";
import avatar3 from "../../assets/home-page/hero-banner-visual/avatar-user-3.jpg";
import iconWallet from "../../assets/home-page/hero-banner-visual/icon-wallet.svg";
import iconPercentUp from "../../assets/home-page/hero-banner-visual/icon-percentage-up-arrow.svg";
import iconSavingsProgress from "../../assets/home-page/hero-banner-visual/icon-savings-progress.svg";
import iconUpArrowPill from "../../assets/home-page/hero-banner-visual/icon-upward-arrow-pill.svg";

export function HeroBannerVisual() {
  return (
    <div className="relative mx-auto mt-16 w-full max-w-[1280px] px-4 xl:pt-[47px]">
      {/* Banner + photo positioning container — kept separate from the
          mobile stat cards below so the photo's bottom-anchoring targets
          the banner's own edge, not the bottom of this whole block. */}
      <div className="relative">
      {/* Gradient banner */}
      <div
        className="relative mx-auto h-[300px] w-full overflow-hidden rounded-[36px] shadow-[0px_4px_25px_rgba(0,0,0,0.03)] sm:h-[420px] xl:h-[508px] xl:max-w-[1280px]"
        style={{
          background:
            "linear-gradient(135.62deg, #F7F3FF 0%, #EFE8FF 50%, #B2FFFE 100%)",
        }}
      >
        {/* Decorative aura */}
        <div
          className="pointer-events-none absolute h-[420px] w-[420px] rounded-full bg-[rgba(217,207,242,0.4)] blur-[20px]"
          style={{ bottom: "-48px", left: "406px" }}
        />

        {/* Floating cards — z-10, above photo */}
        <div className="pointer-events-none absolute inset-0 z-10 hidden xl:block">
          {/* Card 1: Savings */}
          <div
            className="float float-1 absolute flex items-center gap-4 rounded-2xl border border-solid border-white/50 bg-white/95 px-[21px] py-[17px] shadow-[0px_20px_25px_-5px_rgba(62,2,92,0.08),0px_8px_10px_-6px_rgba(62,2,92,0.08)] backdrop-blur-[6px]"
            style={{ left: "845px", top: "245px" }}
          >
            <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#ecfdf5]">
              <img src={iconSavingsProgress} alt="" className="h-6 w-6" />
            </div>
            <div>
              <p className="text-xs font-medium leading-4 text-[#57534e]">
                Savings
              </p>
              <p className="text-lg font-bold leading-[22.5px] text-[#176766]">
                + ₹2,688.00
              </p>
              <p className="text-[11px] font-medium leading-[16.5px] text-[#9ca3af]">
                Saved out of ₹ 8,000
              </p>
            </div>
            <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-[#d1fae5]">
              <img src={iconUpArrowPill} alt="" className="h-4 w-4" />
            </div>
          </div>

          {/* Card 2: Loan Amount Credited */}
          <div
            className="float float-2 absolute flex items-center gap-4 rounded-2xl border border-solid border-white/50 bg-white/95 px-[25px] py-[17px] shadow-[0px_20px_25px_-5px_rgba(62,2,92,0.08),0px_8px_10px_-6px_rgba(62,2,92,0.08)] backdrop-blur-[6px]"
            style={{ left: "65px", bottom: "250px" }}
          >
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#f3edff]">
              <img src={iconWallet} alt="" className="h-6 w-6" />
            </div>
            <div>
              <p className="text-xs font-semibold leading-4 text-[#57534e]">
                Loan Amount Credited
              </p>
              <p className="text-2xl font-extrabold tracking-[-0.6px] leading-8 text-[#3e025c]">
                ₹44,430.00
              </p>
              <p className="text-xs font-medium leading-4 text-[#9ca3af]">
                20th Oct, 2025
              </p>
            </div>
            <div className="flex items-center gap-[2px] rounded-lg border border-solid border-[#d1fae5] bg-[#ecfdf5] px-[11px] py-[5px]">
              <span className="text-xs font-bold leading-4 text-[#176766]">
                +6.01%
              </span>
              <img src={iconPercentUp} alt="" className="h-[14px] w-[14px]" />
            </div>
          </div>

          {/* Card 3: Active users */}
          <div
            className="float float-3 absolute flex items-center gap-3 rounded-2xl border border-solid border-white/50 bg-white/95 px-[21px] py-[13px] shadow-[0px_20px_25px_-5px_rgba(62,2,92,0.08),0px_8px_10px_-6px_rgba(62,2,92,0.08)] backdrop-blur-[6px]"
            style={{ left: "225px", top: "395px" }}
          >
            <div className="flex items-center">
              {[avatar1, avatar2, avatar3].map((src, i) => (
                <img
                  key={i}
                  src={src}
                  alt=""
                  className="h-8 w-8 rounded-full object-cover shadow-[0px_0px_0px_2px_white]"
                  style={{ marginLeft: i === 0 ? 0 : "-10px" }}
                />
              ))}
            </div>
            <div>
              <p className="text-sm font-bold leading-[17.5px] text-[#3e025c]">
                230K+
              </p>
              <p className="text-xs font-medium leading-4 text-[#9ca3af]">
                Active users
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Hero photo — bottom-anchored at every breakpoint so he stays grounded in the card; naturally overlaps the top at xl since the photo is taller than the banner there */}
      <div className="pointer-events-none absolute bottom-0 left-1/2 z-0 h-[220px] w-[190px] -translate-x-1/2 overflow-hidden rounded-[36px] sm:h-[320px] sm:w-[280px] xl:h-[555px] xl:w-[479px] xl:rounded-none xl:rounded-t-[36px]">
        <img
          src={heroPerson}
          alt="Person using GenZ Paisa app on their phone"
          className="h-full w-full object-cover"
        />
      </div>
      </div>

      {/* Mobile/tablet floating stat cards (stacked below banner) */}
      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3 xl:hidden">
        <div className="flex items-center gap-3 rounded-2xl border border-solid border-white/50 bg-white/95 p-4 shadow-[0px_8px_10px_-6px_rgba(62,2,92,0.08)]">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#ecfdf5]">
            <img src={iconSavingsProgress} alt="" className="h-5 w-5" />
          </div>
          <div>
            <p className="text-xs font-medium text-[#57534e]">Savings</p>
            <p className="text-base font-bold text-[#176766]">+ ₹2,688.00</p>
          </div>
        </div>
        <div className="flex items-center gap-3 rounded-2xl border border-solid border-white/50 bg-white/95 p-4 shadow-[0px_8px_10px_-6px_rgba(62,2,92,0.08)]">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#f3edff]">
            <img src={iconWallet} alt="" className="h-5 w-5" />
          </div>
          <div>
            <p className="text-xs font-semibold text-[#57534e]">
              Loan Credited
            </p>
            <p className="text-base font-extrabold text-[#3e025c]">
              ₹44,430.00
            </p>
          </div>
        </div>
        <div className="flex items-center gap-3 rounded-2xl border border-solid border-white/50 bg-white/95 p-4 shadow-[0px_8px_10px_-6px_rgba(62,2,92,0.08)]">
          <div className="flex items-center">
            {[avatar1, avatar2].map((src, i) => (
              <img
                key={i}
                src={src}
                alt=""
                className="h-7 w-7 rounded-full object-cover shadow-[0px_0px_0px_2px_white]"
                style={{ marginLeft: i === 0 ? 0 : "-8px" }}
              />
            ))}
          </div>
          <div>
            <p className="text-sm font-bold text-[#3e025c]">230K+</p>
            <p className="text-xs font-medium text-[#9ca3af]">Active users</p>
          </div>
        </div>
      </div>
    </div>
  );
}
